"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCombinedTransplant = createCombinedTransplant;
const events_1 = require("../../../events");
const patientCondition_1 = require("../../../forms/ltx/patientCondition");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
function createCombinedTransplant({ formatMessage }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.combinedTransplant);
    if (event === undefined) {
        return { value: "-" };
    }
    return {
        value: event.value === patientCondition_1.CombinedTransplant.YES
            ? formatMessage(shared_1.yesNoMessages.YES)
            : "-",
        timestamp: event.timestamp,
        origin: event.origin
    };
}
